import React from 'react';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import { FormLabel } from '../elements/FormLabel';
import { Radiobuttons } from '../elements/Radiobuttons';
import isEqual from 'lodash/isEqual';

const getSelectedItemTitle = selectedType => 
	`${selectedType.count} ${selectedType.title}`;

export class TravellerTypeSelector extends React.Component {
	state = { selectedType: {}, title: '', lastTypes: undefined };

	componentDidMount() {
		this.selectTraveller();
	}

	componentDidUpdate() {
		this.selectTraveller();
	}

	selectTraveller = () => {
		const { selectedType } = this.state;
		this.props.onSelectTraveller([selectedType]);
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		const { types, currentTravellerType } = nextProps;

		if (isEqual(types, prevState.lastTypes)) return null;

		if (isEmpty(types)) return { selectedType: {}, title: '', lastTypes: undefined };

		// select 1 of first type as default
		let selectedType = { ...types[0], count: 1 };
		// if currentTravellerType is set and match exist, use that type instead
		if (
			currentTravellerType &&
			types.find(t => t.name === currentTravellerType.name)
		) {
			selectedType = { ...currentTravellerType, count: 1 };
		}

		return {
			selectedType,
			title: getSelectedItemTitle(selectedType),
			lastTypes: types,
		};
	}

	selectType = name => {
		const { types } = this.props;
		const propType = types.find(t => t.name === name);
		const selectedType = { ...propType, count: 1 };

		this.setState({
			selectedType,
			title: getSelectedItemTitle(selectedType),
		});
	};

	getTitle = () => this.state.title;

	render() {
		const { types = [], texts } = this.props;
		const { selectedType } = this.state;

		if (types.length === 0 || isEmpty(selectedType)) {
			return (
				<>
					<FormLabel className="h3" htmlFor="TravellerTypeDropdown">{texts.private.buyticketpage.tickettypeoptions.travellertype}
					</FormLabel>

					<p>
						<Italic>Välj resa för att se resenärstyper</Italic>
					</p>
				</>
			);
		}

		return (
			<>
				<Container>
					<RadioButtonList
						id="TravellerTypeDropdown"
						name="TravellerTypeDropdown"
						title={texts.private.buyticketpage.tickettypeoptions.travellertype}
						key={this.getTitle()}
						choices={types.map(t => ({ id: t.name, label: t.title }))}
						defaultChoice={selectedType.name}
						onSelect={type => this.selectType(type)}
						renderChoice={(choice, renderRadiobutton) => (
							<>
								<TypeDescription>
									<span className="h4">{choice.label}</span>
									<i>{types.find(t => t.name === choice.id).description}</i>
								</TypeDescription>

								{renderRadiobutton()}
							</>
						)}
					/>
				</Container>
			</>
		);
	}
}

const Italic = styled.em`
	font-size: 16px;
	color: ${props => props.theme.light_grey};
`;

const RadioButtonList = styled(Radiobuttons)`
	flex-direction: column;

	label {
		flex-direction: row-reverse;
		justify-content: flex-end;
	}
`;

const TypeDescription = styled.div`
	text-align: left;
	margin-bottom: 0.7em;

	span {
		display: block;
	}

	.h4 {
		margin: 0;
	}

	i {
		font-size: 0.8em;
	}
`;

const Container = styled.div`
	margin-top: 3rem;
	margin-left: auto;
	margin-right: auto;
	font-size: 1.2em;
`;
